import React from 'react';
import { Box } from '@mui/material';
import TitlePage from '../components/TitlePage';
import CTASection from '../components/CTASection';
import CharteL2MI from '../components/CharteL2MI';
import headerImage from '../assets/images/about/9.jpg';

const PolitiqueQualiteL2MI = () => {
  return (
    <Box>
      <TitlePage 
        title="Politique Qualité L2MI" 
        image={headerImage}
      />
      
      <CharteL2MI />

      <CTASection />
    </Box>
  );
};

export default PolitiqueQualiteL2MI;
